import { createGetAllAPI, createGetAPI, createPatchAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';

import { BASE_URL } from '../constants/api';

const { useGet: useTeacherGet, invalidate: invalidateTeacherGet } = createGetAPI({
  getURL: (id, query) => {
    return `${BASE_URL}/teachers/${id}/?${stringify(query)}/`;
  },
});

const {
  useGet: useTeacherProfileGet,
  invalidate: invalidateTeacherProfileGet,
} = createGetAPI({
  getURL: (id, query) => {
    return `${BASE_URL}/teachers/${id}/profile/`;
  },
});

const {
  useGet: useTeacherSlotsGet,
  invalidate: invalidateTeacherSlotsGet,
} = createGetAPI({
  getURL: (id, query) => {
    return `${BASE_URL}/classroom/teacher-slots/?${stringify(query)}/`;
  },
});

const {
  useGetAll: useTeacherClassroomGet,
  invalidate: invalidateTeacherClassroomGet,
} = createGetAllAPI({
  getURL: (id, query) => {
    return `${BASE_URL}/teachers/${id}/teacher-classrooms/?${stringify(query)}/`;
  },
});

export {
  useTeacherGet,
  invalidateTeacherGet,
  useTeacherProfileGet,
  invalidateTeacherProfileGet,
  useTeacherSlotsGet,
  invalidateTeacherSlotsGet,
  useTeacherClassroomGet,
  invalidateTeacherClassroomGet,
};
